module.exports = __webpack_public_path__ + "img/17.85b2c90e.jpg";